import React, { useEffect, useState } from 'react';
import Table from 'components/preform/Table';
import DeleteModal from 'components/general/DeleteModal';
// import Dropdown from 'components/inputs/DropDown';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { DELETE_FORM, FETCH_FORMS } from 'actions/formActions';
import Pagination from 'components/general/Pagination';
import { Spinner, Modal } from 'react-bootstrap';
import { IconSearch, IconCalendarEvent, IconFilter, IconList, IconLayoutGrid, IconPlus } from '@tabler/icons-react';
import './AllForms.scss';

const AllForms = () => {
  const { forms, totalPages = '', totalResults = '', loading } = useSelector((state) => state.forms);
  const dispatch = useDispatch();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteFormId, setDeleteFormId] = useState(null);
  const [filterSettings, setFilterSettings] = useState({
    page: 1,
    limit: 20,
    sortBy: '-createdAt',
    search: '',
    username: '',
    status: '',
    fromDate: '',
    toDate: '',
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [showNewAppModal, setShowNewAppModal] = useState(false);
  const navigate = useNavigate();
  const [statusFilter, setStatusFilter] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [viewMode, setViewMode] = useState('list');
  const handleCloseDeleteModel = () => {
    setShowDeleteModal(false);
  };
  // const options = [
  //   { label: 'All', value: '' },
  //   { label: 'Admin', value: 'admin' },
  //   { label: 'CE', value: 'engineer' },
  // ];

  useEffect(() => {
    fetchForms();
  }, [JSON.stringify(filterSettings)]);

  const fetchForms = () => {
    const payload = Object.fromEntries(
      Object.entries(filterSettings).filter(([, value]) => value !== '' && value !== null && value !== undefined)
    );
    dispatch({
      type: FETCH_FORMS,
      payload,
    });
  };

  // const setRole = (option) => {
  //   if (option.value != '') {
  //     setFilterSettings((state) => ({ ...state, role: option.value }));
  //   } else {
  //     delete filterSettings.role;
  //     setFilterSettings(filterSettings);
  //   }
  // };

  const handleDeleteBtn = (formId) => {
    setDeleteFormId(formId);
    setShowDeleteModal(true);
  };

  const onRemove = () => {
    dispatch({ type: DELETE_FORM, payload: deleteFormId });
    setShowDeleteModal(false);
  };

  const changePage = ({ selected: pageIndex }) => {
    setFilterSettings((state) => ({ ...state, page: pageIndex + 1 }));
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setFilterSettings((state) => ({ ...state, search: value }));
  };

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setStatusFilter(value);
    setFilterSettings((state) => ({ ...state, status: value }));
  };

  const handleFromDateChange = (e) => {
    const value = e.target.value;
    setFromDate(value);
    setFilterSettings((state) => ({ ...state, fromDate: value }));
  };

  const handleToDateChange = (e) => {
    const value = e.target.value;
    setToDate(value);
    setFilterSettings((state) => ({ ...state, toDate: value }));
  };

  const clearAllFilters = () => {
    setSearchTerm('');
    setStatusFilter('');
    setFromDate('');
    setToDate('');
    setFilterSettings((state) => ({
      ...state,
      search: '',
      status: '',
      fromDate: '',
      toDate: '',
      page: 1,
    }));
  };

  return (
    <div className="all-forms-page">
      <div className="page-body">
        <div className="container-xl new_application">

          <div className="glass-panel filter-section mb-4">
            <div className="d-flex gap-3 flex-wrap align-items-center">
              <div
                className={`filter-input-wrapper expandable-search ${isSearchExpanded || searchTerm ? 'expanded' : ''}`}
                onClick={() => setIsSearchExpanded(true)}
              >
                <IconSearch size={18} className="filter-icon" />
                <input
                  type="text"
                  placeholder="Search by name, station, charger"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  onBlur={() => {
                    if (!searchTerm) setIsSearchExpanded(false);
                  }}
                  className="premium-input search-input"
                  ref={(input) => {
                    if (input && isSearchExpanded && !searchTerm) input.focus()
                  }}
                />
              </div>

              <button
                className="btn premium-btn-secondary d-flex align-items-center gap-2"
                onClick={() => setIsFilterOpen(true)}
              >
                <IconFilter size={18} /> Filters
              </button>

              <div className="d-flex gap-2 ms-auto align-items-center">
                <div className="view-toggle d-flex bg-white rounded-3 p-1 border shadow-sm me-2">
                  <button
                    className={`btn btn-sm border-0 ${viewMode === 'list' ? 'btn-primary shadow-sm' : 'bg-transparent text-secondary'}`}
                    onClick={() => setViewMode('list')}
                    title="List View"
                  >
                    <IconList size={18} stroke={2.5} />
                  </button>
                  <button
                    className={`btn btn-sm border-0 ${viewMode === 'card' ? 'btn-primary shadow-sm' : 'bg-transparent text-secondary'}`}
                    onClick={() => setViewMode('card')}
                    title="Card View"
                  >
                    <IconLayoutGrid size={18} stroke={2.5} />
                  </button>
                </div>
                <button onClick={() => setShowNewAppModal(true)} className="btn btn-primary premium-btn px-2 rounded-circle shadow-sm" style={{ width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} title="New Application">
                  <IconPlus size={20} stroke={2.5} />
                </button>
              </div>
            </div>
          </div>

          <div className="glass-panel table-section">
            <div className="col-12">
              {loading ? (
                <div className="loader-container d-flex justify-content-center py-5">
                  <Spinner animation="border" role="status" variant="primary">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              ) : (
                <>
                  <Table data={forms} handleDeleteBtn={handleDeleteBtn} viewMode={viewMode} />
                  <div className="mt-4 d-flex justify-content-end">
                    <Pagination
                      total={totalResults}
                      handlePageClick={changePage}
                      currentPage={filterSettings.page}
                      limit={filterSettings.limit}
                      totalPages={totalPages}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Offcanvas Filter Menu */}
      <div className={`filter-sidebar-overlay ${isFilterOpen ? 'show' : ''}`} onClick={() => setIsFilterOpen(false)}></div>
      <div className={`filter-sidebar ${isFilterOpen ? 'open' : ''}`}>
        <div className="filter-sidebar-header d-flex justify-content-between align-items-center p-4 border-bottom">
          <h4 className="m-0 fw-bold d-flex align-items-center gap-2"><IconFilter size={20} /> Advanced Filters</h4>
          <button className="btn-close" onClick={() => setIsFilterOpen(false)}></button>
        </div>

        <div className="filter-sidebar-content p-4 d-flex flex-column gap-4">
          <div className="filter-group">
            <label htmlFor="filter-status" className="form-label text-secondary fw-semibold mb-2">Status</label>
            <div className="filter-input-wrapper w-100">
              <IconFilter size={18} className="filter-icon" />
              <select
                id="filter-status"
                value={statusFilter}
                onChange={handleStatusChange}
                className="premium-input premium-select w-100"
              >
                <option value="">Filter by Status</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rework">Re-Work</option>
                <option value="commission">Ready to Commission</option>
                <option value="draft">Draft</option>
              </select>
            </div>
          </div>

          <div className="filter-group">
            <label htmlFor="filter-from-date" className="form-label text-secondary fw-semibold mb-2">From Date</label>
            <div className="filter-input-wrapper w-100">
              <IconCalendarEvent size={18} className="filter-icon" />
              <input
                id="filter-from-date"
                type="date"
                value={fromDate}
                onChange={handleFromDateChange}
                className="premium-input date-input w-100"
              />
            </div>
          </div>

          <div className="filter-group">
            <label htmlFor="filter-to-date" className="form-label text-secondary fw-semibold mb-2">To Date</label>
            <div className="filter-input-wrapper w-100">
              <IconCalendarEvent size={18} className="filter-icon" />
              <input
                id="filter-to-date"
                type="date"
                value={toDate}
                onChange={handleToDateChange}
                className="premium-input date-input w-100"
              />
            </div>
          </div>
        </div>

        <div className="filter-sidebar-footer p-4 border-top mt-auto bg-light">
          <button className="btn premium-btn-secondary w-100 mb-3" onClick={clearAllFilters}>
            Clear All Filters
          </button>
          <button className="btn btn-primary premium-btn w-100" onClick={() => setIsFilterOpen(false)}>
            Apply Filters & Close
          </button>
        </div>
      </div>

      {showDeleteModal && <DeleteModal show={showDeleteModal} title="Form" onClose={handleCloseDeleteModel} onRemove={onRemove} />}

      <Modal show={showNewAppModal} onHide={() => setShowNewAppModal(false)} centered>
        <Modal.Header className="border-0 pb-0 pt-4 px-4 d-flex justify-content-between align-items-center">
          <Modal.Title className="fw-bold fs-4 m-0 d-flex align-items-center gap-2 text-dark">
            <IconPlus size={24} stroke={2} className="text-primary" /> Create New
          </Modal.Title>
          <button className="btn-close" onClick={() => setShowNewAppModal(false)}></button>
        </Modal.Header>
        <Modal.Body className="px-4 py-3 text-secondary" style={{ fontSize: '0.95rem' }}>
          Are you sure you want to create a new application form? All unsaved filter states on this page will be discarded.
        </Modal.Body>
        <Modal.Footer className="border-0 px-4 pb-4 pt-0">
          <button className="btn premium-btn-secondary" onClick={() => setShowNewAppModal(false)}>
            Cancel
          </button>
          <button className="btn btn-primary premium-btn px-4" onClick={() => { setShowNewAppModal(false); navigate('/allforms/form'); }}>
            Proceed
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default AllForms;
